import React from 'react';
import ReactTooltip from 'react-tooltip';

export class UpdatedByRenderer extends React.Component {
    constructor(props) {
        super(props);
        this.elRef = React.createRef();
    }

    tooltipDelay = 400;

    clearTooltipTimer = () => {
        if (!this.tooltipTimer) {
            return;
        }
        window.clearTimeout(this.tooltipTimer);
        this.tooltipTimer = undefined;
    };

    render() {
        let displayValue = this.props.data.lastUpdatedByUser
            ? this.props.data.lastUpdatedByUser.username
            : '';

        if (displayValue) {
            displayValue = displayValue.toUpperCase();
        }

        return (
            <div
                ref={this.elRef}
                style={{
                    textOverflow: 'ellipsis',
                    overflow: 'hidden',
                }}
                data-tip={`${this.props.rowIndex}`}
                data-for={`${this.props.context.gridId}-last-updated-by`}
                onMouseEnter={() => {
                    if (this.tooltipTimer) {
                        return; // prevent double triggering problem on some browsers
                    }

                    this.tooltipTimer = setTimeout(() => {
                        ReactTooltip.show(this.elRef.current);
                        this.clearTooltipTimer();
                    }, this.tooltipDelay);
                }}
                onMouseLeave={() => {
                    this.clearTooltipTimer();
                    ReactTooltip.hide(this.elRef.current);
                }}
            >
                {displayValue}
            </div>
        );
    }
}

export default UpdatedByRenderer;
